import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=676ae2af&scoped=true"
import script from "./EditTag.vue?vue&type=script&lang=js"
export * from "./EditTag.vue?vue&type=script&lang=js"
import style0 from "./EditTag.vue?vue&type=style&index=0&id=676ae2af&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676ae2af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676ae2af')) {
      api.createRecord('676ae2af', component.options)
    } else {
      api.reload('676ae2af', component.options)
    }
    module.hot.accept("./EditTag.vue?vue&type=template&id=676ae2af&scoped=true", function () {
      api.rerender('676ae2af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskExamine/task/components/Tag/EditTag.vue"
export default component.exports